import React from 'react';
import ShareRedirect from './share-redirect';

const ShareActivity = () => <ShareRedirect shareType="activity" />;

export default ShareActivity;
